import axios from "axios";
// import { defaultMethods, messages } from "../../../utils/data";
// import newInstanceAxios from "axios";

const state = {
    UserProfile: {},
    productData: [],
    supplierData: [],
    transitaireData: [],
    storeData: [],
    userData: [],
    conteneurData:[],
    contratData:[],
    contratDataDetails:[],
    blData:[],
    contenuerAllData:[],
    soreStockData:[],
    customerListData:[],
    globaleStockData:[],
    card:[],
    cardDetails:[],
    customerWalletData:[],
    taxData:[],
    taxDataOther:[],
    requestusertransactionData: [],
    returnStockData:[],
    inventoryMissedData: [],
    userWalletData:[],
    reduction: [],
    customerTransaction: [],
    statLink:'',
    statPatch:'',
    priceHistory:[],
    productBuyEstimation: [],
    unitePriceEstimationHistory:[],
    tansitSaveData:[],
    navireListe: [],
    blCoastEstimation:[],
    blCoastEstimationValue:0

};

const getters = {
    UserProfile: (state) => state.UserProfile,
    priceHistory: (state) => state.priceHistory,
    blCoastEstimation: (state) => state.blCoastEstimation,
    blCoastEstimationValue: (state) => state.blCoastEstimationValue,
    navireListe: (state) => state.navireListe,
    tansitSaveData: (state) => state.tansitSaveData,
    unitePriceEstimationHistory: (state) => state.unitePriceEstimationHistory,
    productData: (state) => state.productData,
    supplierData: (state) => state.supplierData,
    transitaireData: (state) => state.transitaireData,
    storeData: (state) => state.storeData,
    userData: (state) => state.userData,
    conteneurData: (state) => state.conteneurData,
    contratData: (state) => state.contratData,
    contratDataDetails: (state) => state.contratDataDetails,
    blData: (state) => state.blData,
    contenuerAllData: (state) => state.contenuerAllData,
    soreStockData: (state) => state.soreStockData,
    customerListData: (state) => state.customerListData,
    globaleStockData: (state) => state.globaleStockData,
    card: (state) => state.card,
    cardDetails: (state) => state.cardDetails,
    customerWalletData: (state) => state.customerWalletData,
    taxData: (state) => state.taxData,
    taxDataOther: (state) => state.taxDataOther,
    requestusertransactionData: (state) => state.requestusertransactionData,
    returnStockData: (state) => state.returnStockData,
    inventoryMissedData: (state) => state.inventoryMissedData,
    userWalletData: (state) => state.userWalletData,
    reduction: (state) => state.reduction,
    customerTransaction: (state) => state.customerTransaction,
    productBuyEstimation: (state) => state.productBuyEstimation,
    statLink: (state) => state.statLink,
    statPatch: (state) => state.statPatch,

};

const mutations = {
    SET_USER_SYSTEME_LOGOUT(state, shouldLogout) {
        if (shouldLogout) {
            localStorage.clear();
            window.location.href = '/login';
        }
    },
    SET_STAT_LINK(state, data) {
        state.statLink = data;
    },
    SET_STAT_PATCH(state, data) {
        state.statPatch = data;
    },
    SET_TRANSIT(state, data) {
        state.tansitSaveData = data;
    },
    // getNavireListe
    SET_NAVIRE_LISTE(state, data) {
        state.navireListe = data;
    },
    SET_PRICE_HYSTORY(state, data) {
        state.priceHistory = data;
    },
    SET_UNIT_PRICE_HYSTORY(state, data) {
        state.unitePriceEstimationHistory = data;
    },
    SET_INVENTORY_MISSED(state, data) {
        state.inventoryMissedData = data;
    },
    SET_USER_WALLET_DATA(state, data) {
        state.userWalletData = data;
    },
    SET_USER_PROFILE(state, data) {
        state.UserProfile = data;
    },
    SET_PRODUCT_DATA(state, data) {
        state.productData = data;
    },
    SET_SUPPLIER_DATA(state, data) {
        state.supplierData = data;
    },
    SET_TRANSITAIRE_DATA(state, data) {
        state.transitaireData = data;
    },
    SET_STORE_DATA(state, data) {
        state.storeData = data;
    },
    SET_USER_DATA(state, data) {
        state.userData = data;
    },
    SET_CONTENEUR_DATA(state, data) {
        state.conteneurData = data;
    },
    SET_CONTRAT_DATA(state, data) {
        state.contratData = data;
    },
    SET_PRODUCT_BUY_DETAILS_DATA(state, data) {
        state.productBuyEstimation = data;
    },
    SET_CONTRAT_DETAILS_DATA(state, data) {
        state.contratDataDetails = data;
    },
    SET_BL_DATA(state, data) {
        state.blData = data;
    },
    SET_CONTENEUR_ALL_DATA(state, data) {
        state.contenuerAllData = data;
    },
    SET_STORE_STOCK_DATA(state, data) {
        state.soreStockData = data;
    },
    SET_CUSTOMER_LISTE_DATA(state, data) {
        state.customerListData = data;
    },
    SET_GLOBALE_STOCK_DATA(state, data) {
        state.globaleStockData = data;
    },
    SET_CARD_DATA(state, data) {
        state.card = data;
    },
    SET_CARD_DETAILS_DATA(state, data) {
        state.cardDetails = data;
    },
    SET_CUSTOMER_WALLET_DATA(state, data) {
        state.customerWalletData = data;
    },
    SET_TAX_DATA(state, data) {
        state.taxData = data;
    },
    SET_TAX_OTHER_DATA(state, data) {
        state.taxDataOther = data;
    },
    SET_REQUEST_USER_TRANSACTION_DATA(state, data) {
        state.requestusertransactionData = data;
    },
    SET_RETURN_STOCK_DATA(state, data) {
        state.returnStockData = data;
    },
    SET_ADMIN_REDUCTE_DATA(state, data) {
        state.reduction = data;
    },
    SET_CUSTOMER_TRANSACTION_DATA(state, data) {
        state.customerTransaction = data;
    },
    SET_BL_COAST_ESTIMATION_DATA(state, data) {
        state.blCoastEstimation = data;
    },
    SET_BL_COAST_ESTIMATION_COAST_DATA(state, data) {
        state.blCoastEstimationValue = data;
    },
};


const actions = {
    getBlCoastEstimation({ commit },{product = '',startDate='', endDate='',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/bl/productaverage?product=${product}&startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_BL_COAST_ESTIMATION_DATA", res.data.data);
                    commit("SET_BL_COAST_ESTIMATION_COAST_DATA", res.data.recapt);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getUnitHistoryPrice({ commit },{product = '',startDate='', endDate='',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/unitCoastPrice?product=${product}&startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_UNIT_PRICE_HYSTORY", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getHistoryPrice({ commit },{product = '',startDate='', endDate='',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/sellingpricehistory?product=${product}&startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    // alert(JSON.stringify(res.data))
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    
                    commit("SET_PRICE_HYSTORY", res.data.data);
                    commit("SET_STAT_LINK", res.data.path);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getCustomerTransaction({ commit },{startDate='', endDate='',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/customerTransaction?startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    commit("SET_CUSTOMER_TRANSACTION_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getNavireListe({ commit },{status=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/contain/uniqueshipname?status=${status}`)
                .then((res) => {
                 
                    commit("SET_NAVIRE_LISTE", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getReductData({ commit },{status=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/reductionrequest?status=${status}`)
                .then((res) => {
                    commit("SET_ADMIN_REDUCTE_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getUserWalletData({ commit },{paymentMethod=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/wallet/groupingbyuserandpaymentmethod?paymentMethod=${paymentMethod}`)
                .then((res) => {
                    commit("SET_USER_WALLET_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getMissingInventory({ commit },{conteneur=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/storeproductlosswithdocument?contain=${conteneur}`)
                .then((res) => {
                    commit("SET_INVENTORY_MISSED", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },










    getReturnToStock({ commit },{conteneur=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/returntostore?contain=${conteneur}`)
                .then((res) => {
                    //  
                    // alert(JSON.stringify(res.data))

                    commit("SET_RETURN_STOCK_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },


    getRequestUserTransaction({ commit },{conteneur=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/requestusertransaction?contain=${conteneur}`)
                .then((res) => {
                    //  
                    // alert(JSON.stringify(res.data))

                    commit("SET_REQUEST_USER_TRANSACTION_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getTaxStat({ commit },{bl='', nature='',startDate='',endDate=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/tax/gettaxsum?bl=${bl}&name=${nature}&startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    //  
                    // alert(JSON.stringify(res.data))

                    commit("SET_TAX_DATA", res.data);
                    resolve(res.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getTaxOfContainer({ commit },{bl='', nature='Taxe'}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/tax?bl=${bl}&nature=${nature}`)
                .then((res) => {
                    //  
                    // alert(JSON.stringify(res.data))

                    commit("SET_TAX_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getTransitContainer({ commit },{bl='', nature='Transit'}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/tax?bl=${bl}&nature=${nature}`)
                .then((res) => {
                    // tansitSaveData 
                    // alert(JSON.stringify(res.data))

                    commit("SET_TRANSIT", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getTaxOtherOfContainer({ commit },{bl='', nature='Autres Taxe'}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/tax?bl=${bl}&nature=${nature}`)
                .then((res) => {
                    // tansitSaveData 
                    // alert(JSON.stringify(res.data))

                    commit("SET_TAX_OTHER_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getCustomerWallet({ commit },{customer=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/customerwallet?customer=${customer}`)
                .then((res) => {
                    //  
                    // alert(JSON.stringify(res.data))

                    commit("SET_CUSTOMER_WALLET_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getUserProfile({ commit }) {
        return new Promise((resolve, reject) => {

            axios
                .get("/user/profile")
                .then((res) => {
                    //  
                    // alert(JSON.stringify(res.data))

                    commit("SET_USER_PROFILE", res.data.data);
                    resolve(res.data.user);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 ) {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        localStorage.setItem("user-token", "");
                        localStorage.setItem("admin-token", "");
                        location.reload();
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getProduct({ commit },{startDate= '', endDate= '',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/product?startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_PRODUCT_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 ) {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                   
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getSupplier({ commit },{startDate='', endDate='',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/supplier?startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    //  
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_SUPPLIER_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getTransitaire({ commit }) {
        return new Promise((resolve, reject) => {

            axios
                .get("/transitaire")
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_TRANSITAIRE_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getStore({ commit },{startDate='', endDate=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/store?startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_STORE_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getUser({ commit }) {
        return new Promise((resolve, reject) => {

            axios
                .get("/user")
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_USER_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getConteneurAll({ commit },{alreadyInStock='Oui',haveAcknowledgeReceiptDate="Non",product='',bl='',shipName='',startDate='',endDate='',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/contain?alreadyInStock=${alreadyInStock}&haveAcknowledgeReceiptDate=${haveAcknowledgeReceiptDate}&product=${product}&bl=${bl}&shipName=${shipName}&startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_CONTENEUR_ALL_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getConteneur({ commit }) {
        return new Promise((resolve, reject) => {

            axios
                .get("/containtype")
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_CONTENEUR_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getContrat({ commit },{startDate='', endDate='',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/contract?startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_CONTRAT_DATA", res.data.data.reverse());
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getBlTracking({ commit },{contract= '',startDate= '',endDate= '',product='', supplier=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/bl/getblrecaptdoc?contract=${contract}&startDate=${startDate}&endDate=${endDate}&product=${product}&supplier=${supplier}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_PRODUCT_BUY_DETAILS_DATA", res.data.data);
                    commit("SET_STAT_PATCH", res.data.path);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getProductPriceBuy({ commit },{contract= '',startDate= '',endDate= '',product='', supplier=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/bl/getaveragepurchasepricesofproductsspermonth?contract=${contract}&startDate=${startDate}&endDate=${endDate}&product=${product}&supplier=${supplier}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_PRODUCT_BUY_DETAILS_DATA", res.data.data);
                    commit("SET_STAT_PATCH", res.data.path);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getContratDetails({ commit },{contract= '',startDate= '',endDate= '',product='', supplier=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/contractdetail?contract=${contract}&startDate=${startDate}&endDate=${endDate}&product=${product}&supplier=${supplier}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_CONTRAT_DETAILS_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getBl({ commit }, {startDate='', endDate= '',}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/bl?startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.link))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_BL_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getStoreStock({ commit },{product= ''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/storestock?product=${product}`)
                .then((res) => {

                    //  
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    // console.log("Value",res.data.data)
                    commit("SET_STORE_STOCK_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getCustomerList({ commit },{startDate = '',endDate = ''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/customer?startDate=${startDate}&endDate=${endDate}`)
                .then((res) => {

                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    // console.log("Value",res.data.data)
                    commit("SET_CUSTOMER_LISTE_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getGlobaleStoreStock({ commit }) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/globalstock`)
                .then((res) => {

                    //  
                    // alert(JSON.stringify(res.data.data))
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    // console.log("Value",res.data.data)
                    commit("SET_GLOBALE_STOCK_DATA", res.data.data);
                    resolve(res.data.data);

                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getFindProductStockDispo({ commit },{product='',quantity=0}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/storestock/checkavailabality?product=${product}&quantity=${quantity}`)
                .then((res) => {
                  
                    resolve(res.data);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getCard({ commit }, {status='',startDate='', endDate= '',alreadyExpired=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/cart?status=${status}&startDate=${startDate}&endDate=${endDate}&alreadyExpired=${alreadyExpired}`)
                .then((res) => {
                    commit("SET_STAT_LINK", '');
                    commit("SET_STAT_PATCH", '');
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_CARD_DATA", res.data.data);
                    commit("SET_STAT_LINK", res.data.link);
                    resolve(res.data.data);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    getCardDetails({ commit }, {status='', cart='',haveReduction='',product='',customer='',startDate='', endDate='',alreadyRemovedAllQuantity=''}) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/cartdetail?status=${status}&cart=${cart}&haveReduction=${haveReduction}&product=${product}&customer=${customer}&startDate=${startDate}&endDate=${endDate}&alreadyRemovedAllQuantity=${alreadyRemovedAllQuantity}`)
                .then((res) => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        res.data.data[i].isSelected = false;
                    }
                    commit("SET_CARD_DETAILS_DATA", res.data.data);
                    resolve(res.data.data);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    printBon({ commit }, {id='', }) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/cart/${id}/printpurshaseorder`)
                .then((res) => {
                    // console.log("myValue",res)
                    window.open(res.data.path, "_blank");
                    // commit("SET_FILES_MANAGE", res.data);
                    resolve(res.data.data);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    printBonMagasin({ commit }, {id='', }) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/cart/${id}/printdeliveryslip`)
                .then((res) => {
                    // console.log("myValue",res)
                    window.open(res.data.path, "_blank");
                    // commit("SET_FILES_MANAGE", res.data);
                    resolve(res.data.data);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
    printBonFacture({ commit }, {id='', }) {
        return new Promise((resolve, reject) => {

            axios
                .get(`/cart/${id}/printinvoice`)
                .then((res) => {
                    // console.log("myValue",res)
                    window.open(res.data.path, "_blank");
                    // commit("SET_FILES_MANAGE", res.data);
                    resolve(res.data.data);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401 && err.response.data.error === 'Token expiré. Veuillez vous reconnecter.') {
                        // alert(JSON.stringify(err.response.data.error)); // Affiche le message d'erreur dans une alerte
                        commit("SET_USER_SYSTEME_LOGOUT", true)
                    } else {
                        console.error(err);
                        reject(err);
                    }
                });
        })
    },
};


export default {
    state,
    getters,
    mutations,
    actions,
};